<template>
  <div>
    <div v-if="!user.grant.chiffre">
      <div class="h-screen flex w-full bg-img">
        <div
          class="
            vx-col
            flex
            items-center
            justify-center
            flex-col
            sm:w-1/2
            md:w-3/5
            lg:w-3/4
            xl:w-1/2
            mx-auto
            text-center
          "
        >
          <img
            src="@/assets/images/pages/404.png"
            alt="graphic-404"
            class="mx-auto mb-4 max-w-full"
          />
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">
            404 - Page introuvable!
          </h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">
            La page que vous demandez est introuvable
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="search_box mb-10">
        <p class="w-strong mb-5">
          Filtrer les statistiques des paiements validé par spécialité et par
          période
        </p>
        <div class="search_box_content">
          <vs-select
            class="w-full"
            label="Type consultation"
            icon="arrow_downward"
            v-model="model.type"
            autocomplete
            @change="getSpecialities"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in types"
            />
          </vs-select>
          <vs-select
            class="w-full"
            label="Spécialités"
            @change="changeSpeciality"
            icon="arrow_downward"
            v-model="model.speciality"
            autocomplete
          >
            <vs-select-item key="0q" value="" text="Tous" />
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in specialities"
            />
          </vs-select>
          <vs-select
            placeholder="Selectionner"
            class="w-full mb-1"
            label="Praticien"
            v-model="model.praticien_id"
            autocomplete
          >
            <vs-select-item key="0q" value="" text="Tous" />
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              @change="changePrac"
              v-for="(item, index) in praticiens"
            />
          </vs-select>
          <vs-select
            placeholder="Status"
            class="w-full mb-1"
            label="Status"
            v-model="model.status"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in etats"
            />
          </vs-select>
          <vs-input
            v-model="model.date_debut"
            class="w-full"
            type="date"
            label="Date début"
          ></vs-input>
          <vs-input
            :min="model.date_debut"
            v-model="model.date_fin"
            class="w-full"
            type="date"
            label="Date fin"
          ></vs-input>
        </div>
        <div class="btn__info">
          <div>
            <h4 class="mt-5">
              Montant total collecté:
              {{ summary.amount != null ? parseFormat(summary.amount) : 0 }}
              Fcfa
            </h4>
          </div>
          <div>
            <vs-button
              @click="filterData"
              class="z-8 mt-5 mr-5"
              color="primary"
              type="filled"
              >Filtrer</vs-button
            >
            <vs-button
              @click="exportData"
              v-if="is_enable"
              class="z-8 mt-5"
              color="primary"
              type="filled"
              >Exporter</vs-button
            >
            <vs-button
              v-else
              disabled
              class="z-8 mt-5"
              color="primary"
              type="filled"
              >Exporter</vs-button
            >
          </div>
        </div>
      </div>
      <vs-table ref="table" :max-items="10" :data="data">
        <template slot="thead">
          <vs-th>Date de validation</vs-th>
          <vs-th>Nom & prénoms</vs-th>
          <vs-th>Montant payé</vs-th>
          <vs-th>Numéro payeur</vs-th>
          <vs-th>Type spécialité</vs-th>
          <vs-th>Spécialité</vs-th>
          <vs-th>Statut</vs-th>
          <vs-th>Code consultation</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <span class="">{{ parseDate(tr.paid_at) }} </span>
              </vs-td>

              <vs-td>
                <span class="">{{ tr.user }} </span>
              </vs-td>
              <vs-td>
                <span class="">{{ parseFormat(tr.amount) }} </span>
              </vs-td>
              <vs-td>
                <span class="">{{ tr.phone }} </span>
              </vs-td>
              <vs-td>
                <span class="">{{ tr.type ? tr.type : "" }}</span>
              </vs-td>
              <vs-td>
                <span class="">{{ tr.speciality ? tr.speciality : "" }}</span>
              </vs-td>

              <vs-td>
                <vs-chip v-if="check == '1'" color="success">Validée</vs-chip>
                <vs-chip v-else color="danger">Expirée</vs-chip>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.code }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination
        v-if="last_page && model.page"
        :total="last_page"
        v-model="model.page"
      ></vs-pagination>
    </div>
  </div>
</template>
<script>
import { _buildQuery, format } from "../../helper/helper";
import moment from "moment";
export default {
  watch: {
    "model.page": function () {
      this.getData();
    },
  },
  data: () => ({
    check: 1,
    information: {},
    last_page: 1,
    filterPrompt: false,
    data: [],
    model: {
      page: 1,
      date_debut: "",
      date_fin: "",
      type: "",
      status: 1,
      speciality: "",
      praticien_id: "",
    },
    specialities: [],
    types: [],
    praticiens: [],
    summary: {},
    user: {},
    etats: [
      { name: "Validé et expiré après 14jrs", id: 1 },
      { name: "Non validé et expiré après 3jrs", id: 2 },
    ],
    spec_name: "",
    pra_name: "",
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("user_cnhu"));
  },
  computed: {
    is_enable() {
      return this.data.length > 0;
    },
  },
  mounted() {
    if (this.user.grant.chiffre) {
      let d = new Date();
      this.model.date_debut = moment(d).format("YYYY-MM-DD");
      this.model.date_fin = moment(d).format("YYYY-MM-DD");
      this.getData();
      this.getType();
    }
  },
  methods: {
    changeSpeciality() {
      if (this.model.speciality != "") {
        const data = this.specialities.filter(
          (el) => el.id === this.model.speciality
        );
        this.spec_name = data[0].name;
        this.model.praticien_id = "";
        if (data[0].praticien != null && data[0].praticien != "") {
          this.getPraticien(data[0].praticien);
        }
      }
    },
    changePrac() {
      if (this.model.praticien_id != "") {
        const data = this.praticiens.filter(
          (el) => el.id === this.model.praticien_id
        );
        this.pra_name = data[0].name;
      }
    },
    getPraticien(id) {
      this.$vs.loading();
      this.$http
        .post("/praticiens/where", { id: id })
        .then((response) => {
          this.praticiens = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },
    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },
    parseFormat(amount) {
      return format(amount);
    },
    parseDate(date) {
      return moment(date).format("DD-MM-YYYY H:mm");
    },
    getSpecialities() {
      let data = this.types.filter((el) => el.id === this.model.type);
      this.pra_name = "";
      this.spec_name = "";
      if (data) {
        this.model.speciality = "";
        this.model.praticien_id = "";
        data = data[0];
        this.specialities = data.specialities;
        //this.specialities.unshift({ id: "", name: "Tous" });
      }
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/statistics/validate-specialities" + _buildQuery(this.model))
        .then((response) => {
          this.data = response.data.payments.data;
          this.last_page = response.data.payments.last_page;
          this.summary = response.data.amount;
          this.check = response.data.status;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },
    getType() {
      this.$http
        .get("/types-specialities")
        .then((response) => {
          this.types = response.data;
          this.types.unshift({
            id: "",
            name: "Tous",
            specialities: [],
          });
        })
        .catch(() => {});
    },
    filterData() {
      this.model.page = 1;
      this.getData();
    },
    exportData() {
      let model = { ...this.model };
      model.spec_name = this.spec_name;
      model.pra_name = this.pra_name;
      this.$vs.loading();
      this.$http
        .post("/statistics/validate-specialities", model, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = link.href = url;
          link.setAttribute("download", "payment_valider_par_specialite.xlsx");
          document.body.appendChild(link);
          link.click();
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search_box {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  min-height: 80px;
  padding: 10px;
  width: 100%;
}
.search_box_content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
}
.z-8 {
  height: 40px;
}
@media only screen and (max-width: 935px) {
  .search_box_content {
    display: grid !important;
    grid-template-columns: 200px 200px 200px 200px !important;
    grid-gap: 10px !important;
  }
}
@media only screen and (max-width: 740px) {
  .search_box_content {
    display: grid !important;
    grid-template-columns: 120px 120px 120px 120px !important;
    grid-gap: 10px !important;
  }
}
@media only screen and (max-width: 640px) {
  .search_box_content {
    display: grid !important;
    grid-auto-flow: row;
    grid-template-columns: 1fr !important;
    grid-gap: 10px !important;
  }
}
.w-strong {
  font-weight: bold;
}
.btn__info {
  display: flex;
  justify-content: space-between;
}
</style>
